import { useTranslation } from "react-i18next";
import PanelsLayout from "components/PanelsLayout";
import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { useParams } from "react-router-dom";
import EmptyPanel from "components/EmptyPanel";
import { useDebounce } from "use-debounce";
import { ItemKind } from "dto/IKindItems";
import ActionsModule from "modules/actionsModule";
import CourtPortalSettings from "components/Settings/CourtPortalSettings";
import CourtPortalCasesRegistry from "components/Registry/CourtPortalCasesRegistry";
import CourtPortalDeliveranceRegistry from "components/Registry/CourtPortalDeliveranceRegistry";

const CourtPortalSettingsWrapper = ({
  setSubtitle,
}: {
  setSubtitle: (t: string) => void;
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    setSubtitle(t("settings.title"));
  }, []);

  return (
    <div className={styles.settingsWrapper}>
      <div className={styles.settings}>
        <div className={styles.title}>{t("registry.piConfiguration")}</div>
        <CourtPortalSettings
          handleDisconnect={() => {}}
          integrationId={0}
          onCanceled={() => {}}
          onSaved={() => {}}
          refetchI={() => {}}
          refetchportals={() => {}}
          grow
        ></CourtPortalSettings>
      </div>
    </div>
  );
};

const CourtPortalModule = () => {
  const { t } = useTranslation();
  const { view } = useParams();
  const [searchText, setSearchText] = useState("");
  const [subtitle, setSubtitle] = useState(() => t("common.all"));
  const [debouncedText] = useDebounce(searchText, 300);

  const handleChangeSearchBar = (text: string) => setSearchText(text);

  const leftPanel = () => {
    if (view === "deliverance") {
      return (
        <CourtPortalDeliveranceRegistry
          id="court"
          kind={ItemKind.CourtPortalDeliverance}
          searchText={debouncedText}
          setSubtitle={setSubtitle}
        ></CourtPortalDeliveranceRegistry>
      );
    }

    if (view === "cases") {
      return (
        <CourtPortalCasesRegistry
          onlyFromCourtPortal={true}
          searchText={debouncedText}
          setSubtitle={setSubtitle}
        ></CourtPortalCasesRegistry>
      );
    }

    if (view === "settings") {
      return (
        <CourtPortalSettingsWrapper
          setSubtitle={setSubtitle}
        ></CourtPortalSettingsWrapper>
      );
    }

    return <div>todo</div>;
  };

  const getLeftPanelTitle = () => {
    if (view === "deliverance") return t("registry.deliveries");
    if (view === "calendar") return t("registry.courtDates");
    if (view === "cases") return t("registry.cases");
    return t("registry.courtPortalModule");
  };

  const rightPanel = () => {
    return <EmptyPanel />;

    // return (
    //   <>
    //     <UserRightSide userId={userId} />
    //     {/* <ClientNew clientId={clientId} /> */}
    //   </>
    // );
  };

  if (view === "calendar") {
    return (
      <ActionsModule
        onlyFromCourtPortal={true}
        header={t("registry.courtDates")}
      ></ActionsModule>
    );
  }

  return (
    <PanelsLayout
      title={getLeftPanelTitle()}
      subTitle={subtitle}
      disableSearch={view === "settings"}
      onChangeSearch={handleChangeSearchBar}
      leftPanel={leftPanel()}
      hideRight={true}
      rightPanel={rightPanel()}
      isSearchExpanded={true}
    />
  );
};
export default CourtPortalModule;
